module.exports = __webpack_public_path__ + "static/media/monitor.28015bb0.svg";